const phoneLikePattern = /^[+\d\s().-]+$/

export function whatsappContactLabel(user) {
  if (!user) return 'WhatsApp user'

  const phoneNumber = String(user.phone_number || '').trim()
  const candidates = [user.name, user.whatsapp_username, user.user_name]
    .map((value) => String(value || '').trim())
    .filter((value) => value && !phoneLikePattern.test(value))
  const name = candidates[0]

  if (name && phoneNumber) return `${name} - ${phoneNumber}`
  return name || phoneNumber || 'WhatsApp user'
}
